// AutoGenerated
export enum EnmBildirimTip {
    "Yoklama" = 1,
    "Eser Başarılı Yorumlanması" = 2,
    "Eser Hatalı Yorumlanması" = 3,
    "Son Kayıt Günü Yaklaşması" = 4,
    "Özel" = 5,
}